export default {
  associations: [],
  parties: [],
  party: [],
};
